import { DeleteFilePayload, SaveFilePayload } from "@cca/components";
import { useServiceProvider } from "@providers";
import { LearnerResponseFileService } from "@services";
import FileService from "@servicesV2/fileService";
import { useMutation } from "@tanstack/react-query";

export function useFileProvider() {
  const { initialization: fileServiceInit } = useServiceProvider(FileService);

  const saveFileMutation = useMutation<number, Error, SaveFilePayload>({
    mutationFn: async ({ file, fileKind, onProgress }) => {
      const { service } = await fileServiceInit;

      const id = await service.saveFile(file, fileKind, onProgress);

      if (id == null) {
        throw new Error("FileService.saveFile returned null");
      }

      return id;
    },
  });

  const deleteFileMutation = useMutation<void, Error, DeleteFilePayload>({
    mutationFn: async ({ id }: DeleteFilePayload) => {
      const { service } = await fileServiceInit;
      await service.deleteFile(id);
    },
  });

  return {
    getFile: async (
      ...args: Parameters<LearnerResponseFileService["downloadFile"]>
    ) => {
      const { service } = await fileServiceInit;

      return service.downloadFile(...args);
    },

    getFileByGuid: async (id: string) => {
      const { service } = await fileServiceInit;

      return service.downloadFileByGuid(id);
    },

    saveFileMutation: saveFileMutation,
    deleteFileMutation: deleteFileMutation,
  };
}
